// ─────────────────────────────────────────────────────────────────────────────
// format.js — every display formatter on the Analytics page.
//
// The three delta formatters exist because the KPI tiles report deltas in three
// different units, and printing the wrong suffix next to a number is a lie the
// user can't detect. `formatDelta` (dashboardService) covers percent deltas;
// these two cover the rest.
// ─────────────────────────────────────────────────────────────────────────────

// getUTCDay, not getDay: the API's dates are UTC calendar days, so a local-time
// read would shift the label by one for viewers west of UTC.
const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

/** "2026-07-22" → "Wed". Falls through to the raw string if it isn't a date. */
export function dayLabel(dateStr) {
  const d = new Date(dateStr);
  return Number.isNaN(d.getTime()) ? dateStr : DAY_NAMES[d.getUTCDay()];
}

/**
 * AVG SESSION DURATION's delta is in hours, not percent, so formatDelta (which
 * appends "%") doesn't fit — same shape, signed, 1 decimal, "h" suffix.
 */
export function formatDeltaHours(deltaHours) {
  const h = deltaHours ?? 0;
  return {
    trend:    h >= 0 ? "up" : "down",
    trendVal: `${h >= 0 ? "+" : ""}${h.toFixed(1)}h`,
  };
}

/**
 * TRUST SCORE / ROUTE SUCCESS deltas arrive as signed points (1 decimal). Trust
 * is a plain 0–100 score (no suffix); route success is a percent (suffix "%").
 * formatDelta stringifies the raw number without forcing 1 decimal, so use this
 * for both instead.
 */
export function formatDeltaPoints(deltaPoints, suffix = "") {
  const p = deltaPoints ?? 0;
  return {
    trend:    p >= 0 ? "up" : "down",
    trendVal: `${p >= 0 ? "+" : ""}${p.toFixed(1)}${suffix}`,
  };
}
